/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Card, Col, Container, Dropdown, Form, Row} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {GUEST_STATUS, IS_REQUEST} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import moment from 'moment';
import Select, {type MultiValue} from 'react-select';
import BookTableForm from './BookTableForm';
import customStyles from 'Common/customStyles';

interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

const BookTable = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.RESTAURANT_BOOK_TABLE;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editBookTable, setBookTable] = useState<any>({});

  const [isEditBookTable, setIsEditBookTable] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortColumn, setSortColumn] = useState('id');
  // console.log('🚀 ~ BookTable ~ setSortColumn:', setSortColumn);

  const [search, setSearch] = useState<string>('');

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const [sortDirection, setSortDirection] = useState('desc');
  // console.log('🚀 ~ BookTable ~ setSortDirection:', setSortDirection);
  const [categoryList, setCategoryList] = useState<CategoryItemType>();
  const [venueList, setVenueList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [filter, setFilter] = useState<{
    venue: Array<{value: string; label: string}>;
    event: Array<{value: string; label: string}>;
  }>({venue: [], event: []});
  const [filteredEvents, setFilteredEvents] = useState<
    Array<{value: string; label: string}>
  >([]);
  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);

  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [modalVideoUrl, setModalVideoUrl] = useState('');
  const [isImage, setIsImage] = useState('');
  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);
  const handleVideoClick = (videoUrl: string, Type: string = 'video'): void => {
    setModalVideoUrl(videoUrl);
    setIsVideoModalOpen(true);
    setIsImage(Type);
  };

  const closeModal = (): void => {
    setIsVideoModalOpen(false);
    setModalVideoUrl('');
    setIsImage('');
  };
  // const [resetSearchFlag, setResetSearchFlag] = useState(false);

  const requestStatus = IS_REQUEST;

  interface Payload {
    venue_id: string[];
    event_id: string[];
  }

  // Define the debounce function
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Define the memoized debounced function
  const debouncedFetchGuestList = useCallback(
    debounce(async (payload: Payload) => {
      try {
        const data: any = await ApiUtils.getRestaurantBookTableList(
          `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
          payload,
        );
        console.log('datadata', data);
        setCategoryList(data as CategoryItemType);
        setTotalRecords(data?.data?.total);
      } catch (error: any) {
        toast.error(error.message);
      }

      setisStatusChange(false);
      setAllChecked(false);
    }, 300),
    [pageValue, pageSize, sortColumn, sortDirection, search],
  );

  // Memoize venue and event IDs
  const venueIds = useMemo(
    () => filter.venue.map(venue => venue.value),
    [filter.venue],
  );
  const eventIds = useMemo(
    () => filter.event.map(event => event.value),
    [filter.event],
  );

  // Memoize the payload
  const payload = useMemo(
    () => ({venue_id: venueIds, restaurant_profile_id: eventIds}),
    [venueIds, eventIds],
  );

  useEffect(() => {
    // Call the debounced function with the payload
    debouncedFetchGuestList(payload);
  }, [
    payload,
    pageValue,
    pageSize,
    sortColumn,
    sortDirection,
    search,
    isEditBookTable,
    iseAddCategory,
    isStatusChange,
  ]);

  console.log(
    'result',
    'Event List:',
    eventList,
    'Filter Event:',
    filter.event,
  );

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected BookTable',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    {
      id: 'userName',
      Header: 'User Name',
      disableFilters: true,
      filterable: true,
      accessor: '',
      Cell: (cell: any) => {
        return (
          <div className="d-flex flex-column">
            {/* Top row: User and Badge */}
            <div className="d-flex align-items-center">
              <span
                className={`badge ${
                  cell.row.original.is_request === 1
                    ? 'bg-primary'
                    : 'bg-secondary'
                } me-2`}
                style={{fontSize: '0.75rem', padding: '2px 6px'}} // Small badge styling
              >
                {cell.row.original.is_request === 1 ? 'New' : 'Existing'}
              </span>
              <div className="user fw-bold">
                {cell.row.original.first_name} {cell.row.original.last_name}
              </div>
            </div>

            {/* Guest details under the user */}
            <div className="guest-details ms-4 mt-1">
              {cell.row.original.guest_detail?.map(
                (guest: any, index: number) => (
                  <div key={index} className="guest-name">
                    {guest?.name}
                    {Boolean(guest?.is_confirm) && (
                      <span
                        className={`badge ms-2 ${
                          guest?.is_confirm === 1
                            ? 'bg-warning'
                            : guest?.is_confirm === 2
                              ? 'bg-success'
                              : 'bg-danger'
                        }`}>
                        {
                          GUEST_STATUS.find(
                            status => status?.id === guest?.is_confirm,
                          )?.title
                        }
                      </span>
                    )}
                  </div>
                ),
              )}
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Total person',
      disableFilters: true,
      filterable: true,
      accessor: '',
      Cell: (cellProps: any) => {
        return (
          <>
            <span>Total : {cellProps.row.original.total_person}</span> <br />[
            <span>Current: {cellProps.row.original.total_person}</span> ,
            <span>
              {' '}
              Previous:{cellProps.row.original.previous_total_person}
            </span>
            ]
          </>
        );
      },
    },
    {
      Header: 'Restaurant',
      disableFilters: true,
      filterable: true,
      accessor: 'restaurant_file', // Assuming 'image' is the property in your data for the image URL
      Cell: ({cell}: any) => {
        return (
          <React.Fragment>
            {(() => {
              const file = cell.row.original.restaurant_file;
              const isImage = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(file);
              const isVideo = /\.(mp4|webm|ogg|mov|avi|flv|mkv)$/i.test(file);

              if (isImage) {
                return (
                  <img
                    src={cell.value}
                    width={60}
                    height={60}
                    alt="Player"
                    onClick={() => handleVideoClick(cell.value, 'image')}
                  />
                );
              } else if (isVideo) {
                return (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '24px',
                      color: 'white',
                      backgroundColor: 'black',
                      padding: '10px',
                      textAlign: 'center',
                      // borderRadius: '100%',
                    }}
                    onClick={() => handleVideoClick(cell.value)}>
                    ▶
                  </div>
                );
              } else {
                return '-';
              }
            })()}
          </React.Fragment>
        );
      },
    },

    {
      Header: 'Restaurant Name',
      disableFilters: true,
      filterable: true,
      accessor: 'restaurant_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Venue Name',
      disableFilters: true,
      filterable: true,
      accessor: 'venue_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Booking Date',
      disableFilters: true,
      filterable: true,
      accessor: 'booking_date',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    {
      Header: 'Booking Type',
      disableFilters: true,
      filterable: true,
      accessor: 'booking_type',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Brunch'
          : cellProps?.value === 2
            ? 'Lunch'
            : 'Dinner';
      },
    },
    {
      Header: 'Phone Number',
      disableFilters: true,
      filterable: true,
      accessor: 'phone',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },

    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'is_request',
      Cell: (cellProps: any) => {
        const guestStatus = requestStatus.find(
          status => status?.id === cellProps?.row?.original?.status,
        );

        return (
          <div className="form-check form-switch d-flex gap-1">
            {guestStatus?.title}
          </div>
        );
      },
    },

    {
      Header: 'Action',
      disableFilters: true,
      filterable: true,
      accessor: (cellProps: any) => {
        return (
          <Dropdown className="text-start">
            <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
              <i className="mdi mdi-dots-horizontal" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu-end">
              <li>
                <Dropdown.Item
                  onClick={() => {
                    setBookTable(cellProps);
                    modalToggle();
                  }}>
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
                  Update User Status
                </Dropdown.Item>
              </li>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  useEffect(() => {
    ApiUtils.getVenueList(`?&type=restaurant_dropDown`)
      .then(async (data: any): Promise<void> => {
        const mappedData = data?.map((data: any) => {
          return {value: data.id, label: data.name};
        });
        setVenueList(mappedData);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
    // void fetchStatus();
    setisStatusChange(false);
    setAllChecked(false);
  }, []);

  const handleSelectVenueChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    // setFilter(prevFilter => ({
    //   ...prevFilter,
    //   event: [...updatedFilterEvent],
    // }));
    setFilter(prevFilter => ({
      ...prevFilter, // Preserve other properties
      venue: [...selectedOptions], // Update venue
    }));
  };

  const handleSelectEventChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setFilter(prevFilter => ({
      ...prevFilter, // Preserve other properties
      event: [...selectedOptions], // Update event
    }));
  };

  useEffect(() => {
    const mappedFilter = filter?.venue?.map((venue: any) => venue?.value);
    console.log('Inside filter useEffect:', filter);
    try {
      ApiUtils.getRestaurantProfileList(
        `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=dropDown`,
        mappedFilter,
      )
        .then(async (data: any): Promise<void> => {
          const formattedData = data?.data?.data?.map((restaurant: any) => ({
            value: restaurant.id, // Ensure this matches your API structure
            label: restaurant.restaurant_name, // Ensure this matches your API structure
          }));
          setEventList(formattedData);

          // setTotalRecords((data as CategoryItemType)?.data?.total);
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    } catch (error) {
      console.error('Error toggling category status:', error);
    }
    // }, [filter]);
  }, [filter.venue, pageValue, pageSize, sortColumn, sortDirection, search]);

  useEffect(() => {
    setFilteredEvents(
      filter.event.filter((filterItem: {value: string; label: string}) =>
        eventList.some(
          (eventItem: {value: string; label: string}) =>
            eventItem.value === filterItem.value,
        ),
      ),
    );
  }, [filter.event, eventList]);
  // Separate useEffect to update the filter state
  useEffect(() => {
    setFilter(prevFilter => {
      if (filteredEvents.length !== prevFilter.event.length) {
        console.log('Inside useEffect with filteredEvents');
        return {...prevFilter, event: filteredEvents};
      }
      return prevFilter;
    });
  }, [filteredEvents]);

  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Restaurant Book Table</h4>
        </div>
        <div id="couponsList">
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body className="bg-soft-light border border-dashed border-start-0 border-end-0">
                  <Form>
                    <Row className="g-3 justify-content-between1 align-items-center">
                      <Col lg={4}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Venue
                          </Form.Label>
                          <Select
                            isMulti
                            className="custom-select"
                            id="venue-name"
                            name="venue-name"
                            value={filter.venue}
                            onChange={handleSelectVenueChange}
                            styles={isDark ? customStyles : {}}
                            // styles={isDark ? colourStyles : {}}
                            options={venueList}></Select>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Restaurant
                          </Form.Label>
                          <Select
                            isMulti
                            className="custom-select"
                            id="event-name"
                            name="event-name"
                            value={filter.event}
                            styles={isDark ? customStyles : {}}
                            // value={selectedCategoryOption}
                            // styles={isDark ? colourStyles : {}}
                            onChange={handleSelectEventChange}
                            options={eventList}></Select>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    // isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search BookTable..."
                    buttonText="Add Event"
                    onClick={() => {
                      setBookTable({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    // resetSearchFlag={resetSearchFlag}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editBookTable.id !== undefined
              ? 'Update Book Table Status'
              : 'Add Event'
          }
          modalBody={
            <>
              <BookTableForm
                handleClose={modalToggle}
                editBookTable={editBookTable}
                setIsEditBookTable={setIsEditBookTable}
                setIsAddCategory={setIsAddCategory}
              />
            </>
          }
        />
        <ModalContainer
          showModal={isVideoModalOpen}
          handleClose={closeModal}
          modalTitle={isImage === 'image' ? 'image' : 'video'}
          size="md"
          isTemplate={true}
          modalBody={
            <>
              {isImage === 'image' ? (
                <img
                  src={modalVideoUrl}
                  alt="Event"
                  className="modal-image-preview"
                />
              ) : (
                <video controls className="modal-image-preview">
                  <source src={modalVideoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </>
          }
        />
      </Container>
    </div>
  );
};

export default BookTable;
